import { Popover as BasePopover } from "@base-ui/react/popover";
import { useFloatingPortalContainer } from "@frontend/contexts";

import type { DatePickerPortalProps } from "./DatePicker.types";

export function DatePickerPortal({
  children,
  ...props
}: DatePickerPortalProps) {
  const container = useFloatingPortalContainer();

  return (
    <BasePopover.Portal
      data-slot="date-picker-portal"
      container={container}
      {...props}
    >
      {children}
    </BasePopover.Portal>
  );
}
